import React, {Component} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import PetitionForm from './PetitionForm';
import PetitionList from './PetitionList';

class PetitionPage extends Component {
    render () {
        return (
            <div className="main">
                <ReactCSSTransitionGroup
                    transitionAppear={true}
                    transitionAppearTimeout={600}
                    transitionEnterTimeout={600}
                    transitionLeaveTimeout={200}
                    transitionName={'SlideIn'}
                >
                <div className="page page-wide align-center">
                    <p><strong>JA!</strong> Jag håller med om att vi ska servera #friskmat inom vård, skola och omsorg!</p>
                    <p className="small">#friskmat = mat som lever upp till de nordiska näringsrekommendationerna, smakar gott och ser aptitlig ut.</p>
                </div>
                <div className="page">
                    <PetitionForm />
                    <PetitionList />
                </div>
                </ReactCSSTransitionGroup>
            </div>
        );
    }
}

export default PetitionPage;


// WEBPACK FOOTER //
// ./src/components/petition/PetitionPage.js